<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-top-border-anchor-link="false"
                                 :has-movie-title="false"
                                 :has-movie="false"
    >
        <template v-slot:feature-summary>
            <img :src="buildImgUrl('feature_summary.png')" alt="Misélの基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <p class="img-01"><img :src="buildImgUrl('contents_01.png')" alt="プロジェクターだからできる新しい写り！デザインも含めて可愛く残せる、新たな盛り体験♡"></p>
                <p class="gif-01"><img :src="buildImgUrl('contents_01_GIF.gif')" alt="動くプロジェクター背景でプリ撮影ができるよ！"></p>
            </div>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <p class="img-01"><img :src="buildImgUrl('contents_02_01.png')" alt="動画を可愛く切り取った3連撮影が超可愛い♡"></p>
                <p class="gif-01"><img :src="buildImgUrl('contents_02_01_GIF.gif')" alt="選んだシーンで、合計9枚撮れる！"></p>
                <p class="img-02"><img :src="buildImgUrl('contents_02_02.png')" alt="選べるデザインは全20種類で、”盛れ”から”映え”まで幅広いデザインを搭載しているよ！"></p>
                <p class="gif-02"><img :src="buildImgUrl('contents_02_02_GIF.gif')" alt="デザイン切り替わりイメージ"></p>
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <p class="img-01"><img :src="buildImgUrl('contents_03.png')" alt="友達との思い出写真やお気に入りの画像など…好きな画像を送って自由に楽しめる♡あなただけの特別な1枚が撮れるよ！"></p>
            </div>
        </template>
        <template v-slot:content-4>
            <div class="cont-04">
                <p class="img-01"><img :src="buildImgUrl('contents_04_01.png')" alt="盛れ感は3種類から選べて、トリミングはバーで自由に調整できるよ！"></p>
                <p class="img-02"><img :src="buildImgUrl('contents_04_02.png')" alt="盛れ感とトリミングの組み合わせ方で、”盛れるプリ”から”映えるプリ”まで自分好みにこだわれる！"></p>
                <p class="gif-02"><img :src="buildImgUrl('contents_04_02_GIF.gif')" alt="操作イメージ"></p>
            </div>
        </template>
        <template v-slot:content-5>
            <div class="cont-05">
                <p class="img-01"><img :src="buildImgUrl('contents_05.png')" alt="プロジェクションプリをフルサイズ印刷で残せるシールが新しい！選んだシーンに合わせて好きなレイアウトで残せるよ！"></p>
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
    name: "MachineEverfilm2",
    components: { LayoutMachineIntroduction },
    data() {
        return {
            machineId: 170,
            sectionTitleList: [
                '01 盛れも映えも叶える「プロジェクションプリ」',
                '02 統一感ある3連撮影の「シーン撮影」',
                '03 好きな画像と撮れる「マイシーン撮影」',
                '04 もっと自分好みにこだわれる「2つのセレクト機能」',
                '05 可愛さそのまま残せる「フチなしシール」',
            ],
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
    }
}
</script>

<style scoped lang="scss">
@use "../../../../scss/v2/base/variables";
@use "sass:math";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            background-color: variables.$color-white;
            
            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(336px, $deviceWidth));
                width: 100%;
                &-link {
                    width: math.percentage(math.div(530px, $deviceWidth));
                }
            }
            .list-anchor-link {
                padding: (variables.$grid-base) 0 (variables.$grid-base * 1.5) 0;

                .img-link {
                    width: math.percentage(math.div(640px, $deviceWidth));
                }
            }

            .feature-summary {
                width: math.percentage(math.div(610px, $deviceWidth));
                padding: 0 0 (variables.$grid-base * 2) 0;
                margin: auto;
            }
        }
        &-contents {
            .accordion-inner {

                .cont-01 {
                    position: relative;

                    .gif-01 {
                        position: absolute;
                        width: math.percentage(math.div(570px, $deviceWidth));
                        top: math.percentage(math.div(82px, $deviceWidth));
                        left: math.percentage(math.div(90px, $deviceWidth));
                    }
                }

                .cont-02 {
                    position: relative;

                    .gif-01 {
                        position: absolute;
                        width: math.percentage(math.div(510px, $deviceWidth));
                        top: math.percentage(math.div(102px, $deviceWidth));
                        left: math.percentage(math.div(120px, $deviceWidth));
                    }

                    .gif-02 {
                        position: absolute;
                        width: math.percentage(math.div(432px, $deviceWidth));
                        top: math.percentage(math.div(502px, $deviceWidth));
                        left: math.percentage(math.div(159px, $deviceWidth));
                    }
                }

                .cont-04 {
                    position: relative;

                    .gif-02 {
                        position: absolute;
                        width: math.percentage(math.div(600px, $deviceWidth));
                        top: math.percentage(math.div(482px, $deviceWidth));
                        left: math.percentage(math.div(75px, $deviceWidth));
                    }
                }
            }
        }
    }
}

</style>
